module.exports = __webpack_public_path__ + "static/img/wenhuayishu-1.0d7785b6.svg";